<template>
  <section class="home-hero">
    <Carousel v-if="banners.length" autoplay :autoplay-speed="5000" loop arrow="never" :radius-dot="true">
      <CarouselItem v-for="item in banners" :key="item.id">
        <a v-if="item.link" :href="item.link" target="_blank" rel="noopener">
          <img :src="resolveAssetUrl(item.image)" :alt="item.alt || item.title" class="hero-img">
        </a>
        <img v-else :src="resolveAssetUrl(item.image)" :alt="item.alt || item.title" class="hero-img">
      </CarouselItem>
    </Carousel>
    <img v-else :src="hero.image" :alt="hero.alt" class="hero-img">
  </section>
</template>

<script>
import { getHomeData } from '@/api'
import { resolveAssetUrl } from '@/utils/api'

export default {
  name: 'HomeCarousel',
  data() {
    return {
      hero: {
        image: require('@/assets/imgs/ysgj_003@2x.png'),
        alt: '源盛国际 专注新西兰签证移民',
      },
      banners: [],
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    resolveAssetUrl,
    async fetchData() {
      try {
        const data = await getHomeData()
        this.hero = {
          image: data.hero?.image || this.hero.image,
          alt: data.hero?.alt || this.hero.alt,
        }
        if (Array.isArray(data.banners) && data.banners.length) {
          this.banners = data.banners
        }
      } catch (error) {
        // 保留默认值，不清空
      }
    },
  },
}
</script>

<style scoped>
.home-hero {
  position: relative;
  height: auto;
  background: #fff;
  overflow: hidden;
}

.hero-img {
  width: 100%;
  height: auto;
  display: block;
}

.home-hero /deep/ .ivu-carousel-dots li {
  margin: 0 5px;
}

.home-hero /deep/ .ivu-carousel-dots li button.radius {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  opacity: 1;
  transition: transform 0.25s ease, background-color 0.25s ease, box-shadow 0.25s ease;
}

.home-hero /deep/ .ivu-carousel-dots li.ivu-carousel-active > button.radius {
  width: 13px;
  height: 13px;
  background: #ffffff;
  border-color: rgba(255, 255, 255, 0.98);
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2), 0 3px 10px rgba(0, 0, 0, 0.14);
  transform: scale(1.02);
}

.home-hero /deep/ .ivu-carousel-dots-inside {
  bottom: 22px;
}
</style>
